<tabset>
  <tab heading="Data">
    <div class="row" *ngIf="widgetType">
      <div class="col-lg-12">
        <div class="row">
          <div class="col-lg-3">
            <div class="form-group input-group-sm">
              <label>Name</label>
              <input type="text" placeholder="name" class="form-control" [(ngModel)]="w.name" />
            </div>
          </div>
          <div class="col-lg-3">
            <div class="form-group input-group-sm">
              <label>Period</label>
              <app-time-period [(period)]="w.period" [type]="'text'"></app-time-period>
            </div>
          </div>
          <div class="col-lg-2">
            <div class="form-group input-group-sm">
              <label>Refresh (Seconds)</label>
              <input min="60" type="text" placeholder="refresh interval" class="form-control"
                [(ngModel)]="w.refreshInterval" />
            </div>
          </div>

          <!-- <div class="col-lg-2">
            <div class="form-group h-100 input-group-sm d-flex align-items-center">

              <input type="checkbox" class="me-2" [(ngModel)]="widget.showTitle" /> Show Title
            </div>
          </div> -->
          
          

          <div class="col-lg-2">
            <div class="form-group input-group-sm">
              <label>Widget Size</label>
              <select [(ngModel)]="w.size" class="input-group form-select">
                <option value="3">3</option>
                <option value="4">4</option>
                <option value="5">5</option>
                <option value="6">6</option>
                <option value="7">7</option>
                <option value="8">8</option>
                <option value="9">9</option>
                <option value="10">10</option>
                <option value="11">11</option>
                <option value="12">12</option>
              </select>
            </div>
          </div>

          <div class="col-lg-2">
            <div class="form-group input-group-sm">
              <label>Widget Height</label>
              <select [(ngModel)]="w.height" class="input-group form-select">
                <option value="400">400</option>
                <option value="450">450</option>
                <option value="500">500</option>
                <option value="600">600</option>
                <option value="700">700</option>
              </select>
            </div>
          </div>

          <div class="col-lg-2">
            <div class="form-group input-group-sm">
              <label>Map Type</label>
              <select [(ngModel)]="w.mapType" class="input-group form-select">
                <option value="open">OpenStreetMap</option>
                <option value="terrain">Google Terrain</option>
                <option value="streets">Google Streets</option>
                <option value="satellite">Google Satellite</option>
              </select>
            </div>
          </div>

          <div class="col-lg-2">
            <div class="form-group input-group-sm">
              <label>Center Latitude</label>
              <input type="number" min="-90" max="90" placeholder="Latitude" class="form-control"
                [(ngModel)]="w.centerLatitude" />
            </div>
          </div>
          <div class="col-lg-2">
            <div class="form-group input-group-sm">
              <label>Center Longitude</label>
              <input type="number" min="-180" max="180" placeholder="Longitude" class="form-control"
                [(ngModel)]="w.centerLongitude" />
            </div>
          </div>
          <div class="col-lg-2">
            <div class="form-group input-group-sm">
              <label>Map Zoom</label>
              <input type="number" min="0" max="20" placeholder="zoomLevel" class="form-control"
                [(ngModel)]="w.zoomLevel" />
            </div>
          </div>
          <div class="col-lg-2">
            <div class="card">
              <div class="card-body d-flex flex-column gap-2">
                <div class="form-group h-100 input-group-sm d-flex align-items-center">
                  <input type="checkbox" class="me-2" [(ngModel)]="w.zoomToBounds" /> Zoom to Bounds
                </div>
              
                <div class="form-group h-100 input-group-sm d-flex align-items-center">
                  <input type="checkbox" class="me-2" [(ngModel)]="w.showLegend" /> Show Legend
                </div>
            
                <div class="form-group h-100 input-group-sm d-flex align-items-center">
                  <input type="checkbox" class="me-2" [(ngModel)]="w.showScale" /> Show Scale
                </div>

                <div class="form-group h-100 input-group-sm d-flex align-items-center">
                  <input type="checkbox" class="me-2" [(ngModel)]="w.showTitle" /> Show Title
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
      <div class="col-lg-5">

      </div>
    </div>
    <div class="row mb-3 mt-3">

      <div class="col-lg-3">
        <button (click)="addTimeSeries()" class="btn btn-primary btn-block" type="submit">
          <i class="fa fa-line-chart"></i> Add Time Series
        </button>
      </div>

    </div>
    <div class="row">
      <div class="col-lg-12">
        <tabset *ngIf="w?.timeSeriesDetailList && w.timeSeriesDetailList.length > 0">
          <tab *ngFor="let tab of w.timeSeriesDetailList" [heading]="tab.displayName == null ? tab.type : tab.displayName"
            [active]="tab.active"
            [heading]="tab.displayName == null ? 'Not Set' : tab.displayName == '' || tab.displayName == null ? tab.uri : tab.displayName"
            (select)="tab.active = true" (deselect)="tab.active = false" [disabled]="tab.disabled"
            [removable]="true" (removed)="removeTimeSeries(tab)">

            <div class="row mt-3">
              <div class="col-lg-12 mb-3">
                <button class="btn btn-sm btn-secondary" (click)="duplicateTimeSeries(tab)" title="Duplicate this time series configuration">
                  <i class="fa fa-copy"></i> Duplicate Time Series
                </button>
              </div>
              <div class="col-lg-6" *ngIf="!widget.tagMatch">
                <div class="form-group input-group-sm">
                  <label>Select Time Series <button [style.background]="tab.colour" [cpPosition]="'bottom'"
                      [(colorPicker)]="tab.colour" class="colour-picker-button"></button></label>
                  <!--<app-time-series-select [timeSeriesDetail]="tab" [enableTagMatch]="true"></app-time-series-select>-->
                  <app-uri-select [showTagMatch]="true" [enableMultiSelect]="true" [customerId]="dashboard.customerId"
                    [timeSeriesDetail]="tab" [enableMediaSearch]="false" [enableTagMatch]="true"
                    [siteTypeCode]="dashboard.siteType" [siteUri]="siteUri"></app-uri-select>
                </div>
                <div class="form-group input-group-sm">
                  <label>Data Type </label>
                  <select [(ngModel)]="tab.displayType" class="input-group form-select">
                    <option value="fixed">Fixed Telemetry</option>
                    <option value="tracker">Moving Device (GPS / Tracker)</option>
                  </select>
                </div>

                <div class="col-lg-12">
                  <div class="form-group input-group-sm">
                    <label>Display Name <span 
                        class="btn btn-outline-secondary btn-sm rounded-circle ms-2" 
                        style="font-size: 12px; width: 20px; height: 20px; padding: 0; line-height: 20px; display: inline-block; cursor: help;"
                        placement="right"
                        [ngbTooltip]="popupHelp">
                        ?
                      </span></label>
                    <input type="text" size="20" [(ngModel)]="tab.displayName" class="form-control" />
                  </div>
                </div>
                <div class="col-lg-12">
                  <div class="form-group form-check input-group-sm">
                    <input type="checkbox" id="showGroupByDefault_{{tab.id}}" [(ngModel)]="tab.showGroupByDefault" class="form-check-input" />
                    <label class="form-check-label" for="showGroupByDefault_{{tab.id}}">Show group by default</label>
                  </div>
                </div>
                <div class="col-lg-12">
                  <div class="form-group form-check input-group-sm">
                    <input type="checkbox" id="groupInLegend_{{tab.id}}" [(ngModel)]="tab.groupInLegend" class="form-check-input" />
                    <label class="form-check-label" for="groupInLegend_{{tab.id}}">
                      Group in legend
                      <span 
                        class="btn btn-outline-secondary btn-sm rounded-circle ms-2" 
                        style="font-size: 12px; width: 20px; height: 20px; padding: 0; line-height: 20px; display: inline-block; cursor: help;"
                        placement="right"
                        [ngbTooltip]="'When checked, items are grouped with a toggle control. When unchecked, items appear as individual entries below all groups.'">
                        ?
                      </span>
                    </label>
                  </div>
                </div>
                
                <div class="col-lg-12">
                  <div class="form-group input-group-sm">
                    <label>Tooltip Template <span 
                        class="btn btn-outline-secondary btn-sm rounded-circle ms-2" 
                        style="font-size: 12px; width: 20px; height: 20px; padding: 0; line-height: 20px; display: inline-block; cursor: help;"
                        placement="right"
                        [ngbTooltip]="popupHelp">
                        ?
                      </span></label>
                    <input type="text" size="20" [(ngModel)]="tab.tooltipTemplate" class="form-control" />
                  </div>
                </div>
                <div class="form-group input-group-sm">
                  <app-transform-editor [transforms]="tab.transforms"></app-transform-editor>
                </div>
              </div>

              <div class="col-lg-6 gy-2">
                <div class="form-row mb-2">
                  <div class="form-group">
                    <label>Display Type</label>
                    <select [(ngModel)]="tab.renderType" class="input-group form-select">
                      <option value="pin">Standard Pin</option>
                      <option value="circle">Circle Pin</option>
                      <option value="geojson">GeoJSON </option>
                      <option *ngIf="tab.displayType === 'tracker'" value="path">Path</option>
                    </select>
                  </div>
                </div>

                <div class="form-row mb-2">
                  <div class="form-group" *ngIf="tab.renderType === 'circle' || tab.renderType === 'geojson'">
                    <label>Use Gradient</label>
                    <input type="checkbox" class="ms-1" [(ngModel)]="tab.useGradient" />
                  </div>
                </div>


                <!-- <div class="form-row">
                <div *ngIf="tab.renderType == 'circle'" class="form-group">
                  <label>Circle Radius (Meters)</label>
                  <input type="number" min="1" placeholder="Radius in meters" class="form-control"
                    [(ngModel)]="tab.circleRadius" />
                </div>
                </div> -->


                <!-- Gradient Selector Component for Circle Pins -->
                <div class="form-row mb-2">
                  <div class="form-group"
                    *ngIf="(tab.renderType === 'circle' || tab.renderType === 'geojson') && tab.useGradient === true">
                    <label>Colour Gradient</label>
                      <span 
                        class="btn btn-outline-secondary btn-sm rounded-circle ms-2" 
                        style="font-size: 12px; width: 20px; height: 20px; padding: 0; line-height: 20px; display: inline-block; cursor: help;"
                        placement="right"
                        [ngbTooltip]="'You can use {tag} to lookup meta tag on the series or {OtherSeries.tag} if you want to do a cross-series lookup for stop point values.'">
                        ?
                      </span>
                    <app-gradient-selector [(stops)]="tab.gradientStops" [(rangeMin)]="tab.gradientRangeMin"
                      [(rangeMax)]="tab.gradientRangeMax"></app-gradient-selector>
                  </div>
                </div>

                <div class="form-row mb-2" *ngIf="tab.renderType === 'pin' && tab.groupInLegend">
                  <input type="text" placeholder="Default Pin Name" class="form-control"
                        [(ngModel)]="tab.defaultPinName" />
                </div>
                <!-- Pin Selector for Standard Pins -->
                <div class="form-row mb-2" *ngIf="tab.renderType === 'pin'">
                  <div class="form-group">
                    <button class="btn btn-sm m-1"
                      [ngClass]="tab.pinKey == pin.key ? 'btn-default btn-primary' : 'btn-outline-default'"
                      *ngFor="let pin of pins" (click)="selectPin($event, pin); tab.pinKey = pin.key">
                      <img style="height:22px" src="/{{pin.iconUrl}}" />
                    </button>
                  </div>
                </div>


                <!-- GeoJSON Layer Selector -->
                <div class="form-row mb-2" *ngIf="tab.renderType === 'geojson'">
                  <div class="form-row">
                    <label>GeoJSON Layer [From Customer Map Layers]</label>
                    <div *ngIf="!layersLoaded" class="form-control text-muted">
                      Loading layers... (Current: {{tab.geoJsonLayer || 'None'}})
                    </div>
                    <select *ngIf="layersLoaded" [(ngModel)]="tab.geoJsonLayer" class="input-group form-select">
                      <option [ngValue]="null">-- Select a layer --</option>
                      <option *ngIf="tab.showTempLayerOption" [ngValue]="tab.geoJsonLayer">{{tab.geoJsonLayer}} (not found)</option>
                      <option *ngFor="let layer of geoJsonLayers" [ngValue]="layer.layerName">{{layer.layerName}}</option>
                    </select>
                  </div>
                </div>

                <!-- Metatag as value -->
                <div class="form-row mb-2">
                  <div class="form-group">
                    <label>Use Point Metatag As Value</label>
                    <span 
                        class="btn btn-outline-secondary btn-sm rounded-circle ms-2" 
                        style="font-size: 12px; width: 20px; height: 20px; padding: 0; line-height: 20px; display: inline-block; cursor: help;"
                        placement="right"
                        [ngbTooltip]="'Enter the metatag no curly braces required.'">
                        ?
                      </span>
                    <input type="checkbox" class="ms-1" [(ngModel)]="tab.useMetaTag" />
                  </div>
                </div>
                <div class="form-row mb-2">
                  <div class="form-group" *ngIf="tab.useMetaTag">
                    <div>
                      <label>Enter Metatag</label>
                      <input type="text" placeholder="Enter metatag" class="form-control"
                        [(ngModel)]="tab.valueMetaTag" />
                    </div>
                  </div>
                </div>

                <!-- Popup HTML Editor -->
                <div class="form-row mb-2">
                  <div class="form-group">
                    <label>Use Custom Popups 
                      <span 
                        class="btn btn-outline-secondary btn-sm rounded-circle ms-2" 
                        style="font-size: 12px; width: 20px; height: 20px; padding: 0; line-height: 20px; display: inline-block; cursor: help;"
                        placement="right"
                        [ngbTooltip]="popupHelp">
                        ?
                      </span>
                    </label>
                    <input type="checkbox" class="ms-1" [(ngModel)]="tab.showPopups" />
                    
                  </div>
                </div>
                <div class="form-row mb-2">
                  <div class="form-group mt-3" *ngIf="tab.showPopups">
                    <ngx-monaco-editor
                      [(ngModel)]="tab.popupHTML"
                      [options]="{ language: 'html', theme: 'vs', readOnly: false, automaticLayout: true, scrollBeyondLastLine: false, minimap: { enabled: false } }"
                      style="display:block; height: 200px; width:100%; overflow: auto;">
                    </ngx-monaco-editor>
                  </div>
                </div>

                <!-- Hide Layer Rules -->
                <div class="form-row mb-2">
                  <div class="form-group">
                    <label>Set Layer Rules</label>
                    <input type="checkbox" class="ms-1" [(ngModel)]="tab.hideLayer" />
                                          <span 
                        class="btn btn-outline-secondary btn-sm rounded-circle ms-2" 
                        style="font-size: 12px; width: 20px; height: 20px; padding: 0; line-height: 20px; display: inline-block; cursor: help;"
                        placement="right"
                        [ngbTooltip]="'The MetaTag value will look at the value on the point. You can use {tag} in the Value field to get a value from the series'">
                        ?
                      </span>
                  </div>
                </div>

                <div class="form-row mb-2" *ngIf="tab.hideLayer">

                  <div *ngFor="let rule of tab.hideRules; let i = index" class="border rounded p-3 mb-3">
                    
                    <!-- Move Up/Down Controls -->
                    <div class="row mb-2">
                      <div class="col-12 d-flex justify-content-between align-items-center">
                        <span class="fw-bold">Rule {{i + 1}}</span>
                        <div class="btn-group btn-group-sm">
                          <button class="btn btn-outline-secondary" (click)="moveRuleUp(tab, i)" [disabled]="i === 0">
                            <i class="fa fa-arrow-up"></i>
                          </button>
                          <button class="btn btn-outline-secondary" (click)="moveRuleDown(tab, i)" [disabled]="i === tab.hideRules.length - 1">
                            <i class="fa fa-arrow-down"></i>
                          </button>
                          <button class="btn btn-danger" (click)="removeHideRule(tab, i)">
                            <i class="fa fa-trash"></i>
                          </button>
                        </div>
                      </div>
                    </div>

                    <!-- Hide/Show Radio Buttons -->
                    <div class="row mb-2">
                      <div class="col-12">
                        <label class="me-3">Action:</label>
                        <div class="form-check form-check-inline">
                          <input class="form-check-input" type="radio" [name]="'hideType_' + i" 
                                 value="hide" [(ngModel)]="rule.hideType" id="hide_{{i}}">
                          <label class="form-check-label" for="hide_{{i}}">Hide</label>
                        </div>
                        <div class="form-check form-check-inline">
                          <input class="form-check-input" type="radio" [name]="'hideType_' + i" 
                                 value="show" [(ngModel)]="rule.hideType" id="show_{{i}}">
                          <label class="form-check-label" for="show_{{i}}">Show</label>
                        </div>
                        <div class="form-check form-check-inline" *ngIf="tab.renderType === 'pin'">
                          <input class="form-check-input" type="radio" [name]="'hideType_' + i" 
                                 value="bounce-slow" [(ngModel)]="rule.hideType" id="bounceSlow_{{i}}">
                          <label class="form-check-label" for="bounceSlow_{{i}}">Bounce Slow</label>
                        </div>
                        <div class="form-check form-check-inline" *ngIf="tab.renderType === 'pin'">
                          <input class="form-check-input" type="radio" [name]="'hideType_' + i" 
                                 value="bounce-fast" [(ngModel)]="rule.hideType" id="bounceFast_{{i}}">
                          <label class="form-check-label" for="bounceFast_{{i}}">Bounce Fast</label>
                        </div>
                        <div class="form-check form-check-inline" *ngIf="tab.renderType === 'circle'">
                          <input class="form-check-input" type="radio" [name]="'hideType_' + i" 
                                 value="pulse-slow" [(ngModel)]="rule.hideType" id="pulseSlow_{{i}}">
                          <label class="form-check-label" for="pulseSlow_{{i}}">Pulse Slow</label>
                        </div>
                        <div class="form-check form-check-inline" *ngIf="tab.renderType === 'circle'">
                          <input class="form-check-input" type="radio" [name]="'hideType_' + i" 
                                 value="pulse-fast" [(ngModel)]="rule.hideType" id="pulseFast_{{i}}">
                          <label class="form-check-label" for="pulseFast_{{i}}">Pulse Fast</label>
                        </div>
                      </div>
                    </div>

                    <!-- Rule Criteria -->
                    <div class="row align-items-center mb-2">
                      <div class="col-3">
                        <label class="form-label-sm">MetaTag</label>
                        <input type="text" [(ngModel)]="rule.metaTag" class="form-control form-control-sm"
                          placeholder="MetaTag (leave blank for value)" />
                      </div>

                      <div class="col-2">
                        <label class="form-label-sm">Operator</label>
                        <select [(ngModel)]="rule.operator" class="form-select form-select-sm">
                          <option value="lessThan">&lt;</option>
                          <option value="lessThanEqual">&lt;=</option>
                          <option value="greaterThan">&gt;</option>
                          <option value="greaterThanEqual">&gt;=</option>
                          <option value="equal">=</option>
                          <option value="notEqual">!=</option>
                          <option value="stringEqual">String=</option>
                          <option value="stringNotEqual">String!=</option>
                        </select>
                      </div>

                      <div class="col-2">
                        <label class="form-label-sm">Value</label>
                        <input type="text" [(ngModel)]="rule.value" class="form-control form-control-sm"
                          placeholder="Value" />
                      </div>

                      <div class="col-3">
                        <label class="form-label-sm" *ngIf="rule.hideType === 'show' && tab.renderType === 'pin'">Label</label>
                        <input type="text" [(ngModel)]="rule.label" class="form-control form-control-sm"
                          placeholder="Label" *ngIf="rule.hideType === 'show' && tab.renderType === 'pin'"/>
                      </div>

                      <!-- Pin Selector (only shown when hideType is not 'hide') -->
                      <div class="col-2" *ngIf="rule.hideType === 'show' && tab.renderType === 'pin'">
                        <label class="form-label-sm">Pin:</label>
                        <div style="position: relative;">
                          <button class="btn btn-outline-default btn-sm" (click)="rule.showMenu = !rule.showMenu">
                            <img *ngIf="rule.pinName && getPin(rule.pinName)" style="height:22px" src="/{{getPin(rule.pinName).iconUrl}}" />
                            <span *ngIf="!rule.pinName || !getPin(rule.pinName)">Select Pin</span>
                          </button>
                          <div class="toggle-menu toggle-menu-right" *ngIf="rule.showMenu">
                            <button class="btn btn-outline-default btn-sm" *ngFor="let pin of pins" (click)="selectPinForRule(rule, pin)">
                              <img style="height:22px" src="/{{pin.iconUrl}}" />
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>

                  </div>

                  <button class="btn btn-sm btn-primary mt-2" (click)="addHideRule(tab)">
                    <i class="fa fa-plus"></i> Add Rule
                  </button>

                </div>


              </div>

            </div>
          </tab>
        </tabset>
      </div>
    </div>
  </tab>

  <!-- Layers Tab -->
  <tab heading="Layers">
    <div class="row mb-3">
      <div class="col-lg-10">
        <div class="form-group input-group-sm">
          <label>Select Map Layer</label>
          <select [(ngModel)]="selectedLayerId" class="form-select">
            <option [value]="null">-- Select a layer --</option>
            <option *ngFor="let layer of allMapLayers" [value]="layer.mapLayerId">
              {{layer.path ? layer.path + ' / ' : ''}}{{layer.layerName}} ({{layer.layerType}})
            </option>
          </select>
        </div>
      </div>
      <div class="col-lg-2 d-flex align-items-end">
        <button class="btn btn-primary" (click)="addLayer()" [disabled]="!selectedLayerId">Add Layer</button>
      </div>
    </div>

    <table class="table table-striped">
      <thead>
        <tr>
          <th>Name</th>
          <th>Type</th>
          <th>Path</th>
          <th>Active</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngIf="widget.layers == null || widget.layers.length == 0">
          <td colspan="5">No Layers Added</td>
        </tr>
        <tr *ngFor="let layer of widget.layers">
          <ng-container *ngIf="getLayerDetails(layer.mapLayerId) as layerDetails">
            <td>{{layerDetails.layerName}}</td>
            <td>{{layerDetails.layerType}}</td>
            <td>{{layerDetails.path || '-'}}</td>
            <td>
              <div class="form-switch">
                <input type="checkbox" class="form-check-input" [(ngModel)]="layer.active">
              </div>
            </td>
            <td>
              <button class="btn btn-sm btn-danger" (click)="removeLayer(layer)">
                <i class="fa fa-trash"></i>
              </button>
            </td>
          </ng-container>
        </tr>
      </tbody>
    </table>
  </tab>
</tabset>
